import React from 'react';

import { AgentGuidline } from './AgentGuidline';

export const ManagerGuidline = () => {
    return (
        <>
            <div>
                This should be a very <span> detailed </span> discussion about if they are achieving/achieved the KPI’s. 
                Remember, KPI’s are a contractual agreement we have with our clients to achieve and thrive in
                certain areas.  <br />
                Is there something happening that is preventing them from meeting the KPI’s? 
            </div>
             
            <div>
                If P4P is applicable, did they meet the goals, what did they miss and why?  <br /> Ensure they
                understand the reward program. 
            </div>
            <AgentGuidline />
            <div> Did you apply A3I methods</div>
            <div>
                <ul>
                    <li>Have you Analyzed the data prior to speaking to them? </li>
                    <li>Are you clearly Articulating your expectations?</li>
                    <li>Are you both Aligning on the next steps and the Improvement plan? </li>
                    <li>
                        Lastly,  you should spot check, check in randomly to Inspect they are demonstrating
                        the areas you discussed. 
                    </li>
                </ul>
            </div>
        </>
    );
};
